(() => {
  if (window.__preaRelatedProductsViewMore) return;
  window.__preaRelatedProductsViewMore = true;

  const getHiddenItems = (recommendations) => {
    const hiddenClass = window.matchMedia('(min-width: 750px)').matches
      ? 'related-products__item--hidden-desktop'
      : 'related-products__item--hidden-mobile';

    return Array.from(recommendations.querySelectorAll(`.${hiddenClass}:not(.is-load-more-visible)`));
  };

  const revealItems = (items) => {
    items.forEach((item, index) => {
      item.style.setProperty('--prea-load-more-index', String(index));
      item.classList.add('is-load-more-visible', 'is-load-more-revealing');
      item.addEventListener('animationend', () => {
        item.classList.remove('is-load-more-revealing');
        item.style.removeProperty('--prea-load-more-index');
      }, { once: true });
    });
  };

  const fetchNextItems = async (recommendations, button) => {
    const nextUrl = button.dataset.relatedProductsNextUrl;
    if (!nextUrl) return [];

    const requestUrl = new URL(nextUrl, window.location.origin);
    requestUrl.searchParams.set('section_id', recommendations.dataset.relatedProductsSectionId);

    const response = await fetch(requestUrl.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error(`Related products request failed: ${response.status}`);

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const remoteRecommendations = documentFragment.querySelector('[data-related-products]');
    const remoteGrid = remoteRecommendations?.querySelector('.product-grid');
    if (!remoteGrid) throw new Error('Related products response did not contain the expected grid.');

    const grid = recommendations.querySelector('.product-grid');
    const existingIds = new Set(
      Array.from(grid.querySelectorAll('[data-related-product-id]')).map((item) => item.dataset.relatedProductId)
    );
    const nextItems = Array.from(remoteGrid.querySelectorAll('[data-related-product-id]'))
      .filter((item) => !existingIds.has(item.dataset.relatedProductId));

    nextItems.forEach((item) => {
      item.classList.add('related-products__item--hidden-desktop', 'related-products__item--hidden-mobile');
      grid.appendChild(item);
    });

    const remoteButton = remoteRecommendations.querySelector('[data-related-products-view-more]');
    button.dataset.relatedProductsNextUrl = remoteButton?.dataset.relatedProductsNextUrl || '';

    return nextItems;
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-related-products-view-more]');
    if (!button || button.disabled) return;

    const recommendations = button.closest('[data-related-products]');
    if (!recommendations) return;

    const control = button.closest('.related-products__view-all');
    const status = recommendations.querySelector('[data-related-products-status]');
    let nextItems = getHiddenItems(recommendations).slice(0, 8);

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      while (nextItems.length < 8 && button.dataset.relatedProductsNextUrl) {
        await fetchNextItems(recommendations, button);
        nextItems = getHiddenItems(recommendations).slice(0, 8);
      }

      revealItems(nextItems);

      const loadedCount = recommendations.querySelectorAll('.related-products__item').length;
      const visibleCount = loadedCount - getHiddenItems(recommendations).length;
      const totalCount = Number(recommendations.dataset.relatedProductsTotalCount) || visibleCount;
      if (status) {
        status.textContent = recommendations.dataset.relatedProductsStatusTemplate
          .replace('[visible]', String(Math.min(visibleCount, totalCount)))
          .replace('[total]', String(totalCount));
      }
    } catch (error) {
      console.error(error);
      if (status) status.textContent = recommendations.dataset.relatedProductsErrorMessage;
    } finally {
      const remainingItems = getHiddenItems(recommendations);
      const hasNextPage = Boolean(button.dataset.relatedProductsNextUrl);
      const hasMore = remainingItems.length > 0 || hasNextPage;

      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.setAttribute('aria-expanded', String(!hasMore));

      if (!hasMore) control?.setAttribute('hidden', '');
    }
  });
})();
